import { Injectable } from "@angular/core";
import { BaseCrudService } from "../../../core/data/services/base-crud.service";
import Policy from "../../../core/data/models/policy.mode";
import VehiclePolicy from "../../../core/data/models/vehicle.policy.model";
import HousePolicy from "../../../core/data/models/house.policy.model";
import TravelPolicy from "../../../core/data/models/travel.policy.model";

@Injectable()
export class PolicyService extends BaseCrudService<Policy> {
    controller = 'Policies';

    getMyPolicies(idNumber: string) {
        return this.get<Policy[]>({}, idNumber)
    }

    getVehiclePolicyDetail(policyNumber: string, idNumber: string) {
        return this.get<VehiclePolicy[]>({
            idNumber
        }, `${policyNumber}/Vehicles`)
    }

    getHousePolicyDetail(policyNumber: string, idNumber: string) {
        return this.get<HousePolicy[]>({
            idNumber
        }, `${policyNumber}/Houses`)
    }

    getTravelPolicyDetail(policyNumber: string, idNumber: string) {
        return this.get<TravelPolicy[]>({
            idNumber
        }, `${policyNumber}/Travels`)
    }
}